import { render, staticRenderFns } from "./sku-detail.vue?vue&type=template&id=719b7d80&scoped=true&"
import script from "./sku-detail.vue?vue&type=script&lang=js&"
export * from "./sku-detail.vue?vue&type=script&lang=js&"
import style0 from "./sku-detail.vue?vue&type=style&index=0&id=719b7d80&scoped=true&lang=scss&"
import style1 from "./sku-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b7d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VPagination,VRow,VSelect,VSimpleTable,VTextField,VTooltip})
